// extracted by mini-css-extract-plugin
export default {"command_font":"style_command_font__VbVPo"};